var swiper = new Swiper(".article-blog-slider", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // when window width is >= 1024px
    1200: {
      slidesPerView: 3,
      spaceBetween: 30, // adjust as needed
    },
    // when window width is >= 768px
    750: {
      slidesPerView: 2,
      spaceBetween: 20, // adjust as needed
    },
    // when window width is >= 480px
    0: {
      slidesPerView: 1,
      spaceBetween: 10, // adjust as needed
    },
  }
});
